// TopNavCliente — variante CLIENTE del TopNav v5 (mismo look, rutas del panel).
// FIX D (Nico: "look v5, rutas cliente"): el shell del panel /cliente se ve idéntico a la tienda
// pública (barra sticky dark, blur, tokens --tv5-*, logo izq + actions der) pero los items son las
// 7 secciones del panel, no las públicas. Cerrar sesión + "Volver a la tienda" viven en las actions
// (desktop) y en el drawer (mobile). Sin badge de carrito (el panel no usa el carrito público).
//
// Self-contained: <style>{CLNAV_CSS}</style> + clases .clnav-* + tokens --tv5-* propios. El active
// state se computa desde useLocation (drop-in: ClienteLayout no necesita pasar nada).
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/AuthContext';
import { supabase } from '../../lib/supabase';

const TIENDA_PUBLICA = 'https://tienda.limpack.uy/catalogo';

// Las 7 secciones del panel (orden pedido por Nico).
const NAV = [
  { key: 'inicio',  label: 'Inicio',    to: '/cliente' },
  { key: 'mi-plan', label: 'Mi Plan',   to: '/cliente/mi-plan' },
  { key: 'pedidos', label: 'Pedidos',   to: '/cliente/pedidos' },
  { key: 'vecinos', label: 'Vecinos',   to: '/cliente/vecinos' },
  { key: 'soporte', label: 'Soporte',   to: '/cliente/soporte' },
  { key: 'cuenta',  label: 'Mi cuenta', to: '/cliente/cuenta' },
  { key: 'tienda',  label: 'Tienda',    to: '/catalogo' },
];

const CLNAV_CSS = `
.clnav {
  --tv5-teal:#00A8B5; --tv5-navy:#1A3461; --tv5-accent:var(--tv5-teal);
  --tv5-text:#F8F6F1; --tv5-muted:rgba(248,246,241,0.65); --tv5-border:rgba(255,255,255,0.08);
  position:sticky; top:0; z-index:100; background:rgba(10,20,36,0.9);
  backdrop-filter:blur(20px); -webkit-backdrop-filter:blur(20px);
  border-bottom:1px solid var(--tv5-border); padding:12px 16px;
  display:flex; align-items:center; justify-content:space-between; gap:12px;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
}
.clnav-logo-img { display:block; height:28px; width:auto; }
@media (min-width:900px){ .clnav-logo-img { height:32px; } }
.clnav-links { display:none; gap:20px; align-items:center; flex:1; justify-content:center; }
.clnav-links a { color:var(--tv5-muted); text-decoration:none; font-size:13px; font-weight:500; white-space:nowrap; }
.clnav-links a.active { color:var(--tv5-accent); }
@media (hover:hover){ .clnav-links a:hover { color:var(--tv5-accent); } }
@media (min-width:900px){ .clnav-links { display:flex; } .clnav-burger { display:none !important; } .clnav-logout-desktop { display:inline-flex !important; } }
.clnav-actions { display:flex; gap:8px; align-items:center; }
.clnav-user {
  display:inline-flex; align-items:center; gap:8px; text-decoration:none;
  background:rgba(255,255,255,0.06); border:1px solid var(--tv5-border); border-radius:999px;
  padding:5px 12px 5px 5px; color:var(--tv5-text); max-width:46vw; overflow:hidden;
}
@media (hover:hover){ .clnav-user:hover { border-color:rgba(0,168,181,0.3); } }
.clnav-avatar {
  width:30px; height:30px; border-radius:50%; flex-shrink:0;
  background:linear-gradient(135deg,#00A8B5,#7dd3fc); display:inline-flex; align-items:center;
  justify-content:center; font-weight:800; color:var(--tv5-navy); font-size:13px;
}
.clnav-username { font-size:13px; font-weight:700; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.clnav-logout-desktop {
  display:none; align-items:center; background:rgba(255,255,255,0.06); border:1px solid var(--tv5-border);
  color:var(--tv5-text); border-radius:999px; padding:8px 16px; font-size:12px; font-weight:700; cursor:pointer; font-family:inherit;
}
@media (hover:hover){ .clnav-logout-desktop:hover { border-color:rgba(0,168,181,0.3); } }
.clnav-icon {
  background:rgba(255,255,255,0.06); border:1px solid var(--tv5-border); color:var(--tv5-text);
  min-width:44px; min-height:44px; display:inline-flex; align-items:center; justify-content:center;
  border-radius:10px; font-size:15px; cursor:pointer;
}
/* Drawer mobile */
.clnav-drawer-bg { position:fixed; inset:0; background:rgba(0,0,0,0.6); backdrop-filter:blur(4px);
  z-index:110; opacity:0; pointer-events:none; transition:opacity 0.25s; }
.clnav-drawer-bg.open { opacity:1; pointer-events:auto; }
.clnav-drawer {
  position:fixed; top:0; right:0; bottom:0; width:min(300px,82vw); z-index:111;
  background:#0A1424; border-left:1px solid var(--tv5-border); padding:20px;
  transform:translateX(100%); transition:transform 0.3s cubic-bezier(0.34,1.56,0.64,1);
  display:flex; flex-direction:column; gap:4px; overflow-y:auto;
}
.clnav-drawer.open { transform:translateX(0); }
.clnav-drawer-close { align-self:flex-end; background:rgba(255,255,255,0.06); border:1px solid var(--tv5-border);
  color:var(--tv5-muted); width:44px; height:44px; border-radius:10px; font-size:20px; cursor:pointer; margin-bottom:8px; }
.clnav-drawer-user { display:flex; align-items:center; gap:10px; padding:10px; margin-bottom:8px;
  border-radius:12px; background:rgba(255,255,255,0.06); border:1px solid var(--tv5-border); }
.clnav-drawer-user-info { min-width:0; flex:1; }
.clnav-drawer-user-name { font-size:13px; font-weight:700; color:#fff; }
.clnav-drawer-user-email { font-size:11px; color:var(--tv5-muted); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.clnav-drawer a { color:var(--tv5-text); text-decoration:none; font-size:15px; font-weight:600;
  padding:13px 12px; border-radius:10px; min-height:44px; display:flex; align-items:center; }
.clnav-drawer a.active { color:var(--tv5-accent); background:rgba(0,168,181,0.10); }
.clnav-drawer-sep { height:1px; background:var(--tv5-border); margin:10px 0; }
.clnav-drawer-tienda { color:var(--tv5-muted) !important; font-weight:600; }
.clnav-drawer-logout { margin-top:6px; background:rgba(255,255,255,0.06); border:1px solid var(--tv5-border);
  color:var(--tv5-text); border-radius:10px; padding:13px; font-size:14px; font-weight:700; cursor:pointer; font-family:inherit; }
@media (min-width:900px){ .clnav-drawer, .clnav-drawer-bg { display:none; } }
@media (prefers-reduced-motion:reduce){ .clnav-drawer, .clnav-drawer-bg { transition:none; } }
`;

export function TopNavCliente() {
  const [open, setOpen] = useState(false);
  const { user, profile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  function isActive(to) {
    if (to === '/cliente') return path === '/cliente' || path === '/cliente/';
    return path.startsWith(to);
  }

  async function handleLogout() {
    await supabase.auth.signOut();
    navigate('/login');
  }

  const initial = (profile?.nombre || user?.email || 'U').charAt(0).toUpperCase();
  const displayName = profile?.nombre?.split(' ')[0] || (user?.email || '').split('@')[0];
  const fullEmail = user?.email || '';

  return (
    <>
      <nav className="clnav">
        <style>{CLNAV_CSS}</style>
        <Link to="/cliente" className="clnav-logo" aria-label="Limpack — Mi cuenta">
          <img src="/logo-nav.png" alt="Limpack" className="clnav-logo-img" />
        </Link>

        <div className="clnav-links">
          {NAV.map((l) => (
            <Link key={l.key} to={l.to} className={isActive(l.to) ? 'active' : undefined}>{l.label}</Link>
          ))}
        </div>

        <div className="clnav-actions">
          <Link to="/cliente/cuenta" className="clnav-user" title={fullEmail}>
            <span className="clnav-avatar">{initial}</span>
            <span className="clnav-username">{displayName}</span>
          </Link>
          <button className="clnav-logout-desktop" onClick={handleLogout}>Cerrar sesión</button>
          <button className="clnav-icon clnav-burger" aria-label="Menú" onClick={() => setOpen(true)}>☰</button>
        </div>
      </nav>

      {/* Drawer FUERA del <nav>: el backdrop-filter del nav crea un containing block que atraparía
          los position:fixed del drawer/backdrop → no cubrirían el viewport. */}
      <div className={'clnav-drawer-bg' + (open ? ' open' : '')} onClick={() => setOpen(false)} />
      <div className={'clnav-drawer' + (open ? ' open' : '')} role="dialog" aria-label="Menú">
        <button className="clnav-drawer-close" onClick={() => setOpen(false)} aria-label="Cerrar menú">×</button>
        <div className="clnav-drawer-user">
          <span className="clnav-avatar">{initial}</span>
          <div className="clnav-drawer-user-info">
            <div className="clnav-drawer-user-name">{displayName}</div>
            <div className="clnav-drawer-user-email">{fullEmail}</div>
          </div>
        </div>
        {NAV.map((l) => (
          <Link key={l.key} to={l.to} className={isActive(l.to) ? 'active' : undefined} onClick={() => setOpen(false)}>{l.label}</Link>
        ))}
        <div className="clnav-drawer-sep" />
        <a href={TIENDA_PUBLICA} className="clnav-drawer-tienda" onClick={() => setOpen(false)}>← Volver a la tienda</a>
        <button className="clnav-drawer-logout" onClick={handleLogout}>Cerrar sesión</button>
      </div>
    </>
  );
}
